import React from 'react';

function Divider() {
  return <hr className="m-0 border-none bg-primary h-px" />;
}

export default Divider;
